import { observer } from 'mobx-react';
import './RulesModal.scss';
import { ModalWrapper } from '../../platform/components/modal/ModalWrapper';
import { PayTable } from '../../platform/components/pay-table/PayTable';
import { gameStore, userStore, useTranslation, utilsStore } from '../../platform/stores';
import { c } from '../../platform/utils';

export const RulesModal = observer(() => {
  const { currency } = userStore;
  const { showRulesModal, setShowRulesModal } = utilsStore;
  const { minBetAmount, maxBetAmount, maxWinAmount } = gameStore;
  const t = useTranslation();

  const close = () => {
    setShowRulesModal(false);
  }

  return (
    <ModalWrapper hidden={!showRulesModal} onClose={() => close()}>
      <div className="rules-modal-component">
        <div className="close-btn" onClick={() => close()}></div>
        <div className="content">
          <div className="limits">
            <h2>{t('RULES_GAME_LIMITS')}</h2>
            <pre>
              {t('RULES_GAME_LIMITS_DESCRIPTION', c(minBetAmount, currency), c(maxBetAmount, currency), c(maxWinAmount, currency))}
            </pre>
          </div>
          <div className="description">
            <h2>{t('RULES_GAME_DESCRIPTION')}</h2>
            <pre>{t('RULES_GAME_DESCRIPTION_INFO')}</pre>
          </div>
          <div className="how-to-play">
            <h2>{t('RULES_HOW_TO_PLAY')}</h2>
            <pre>{t('RULES_HOW_TO_PLAY_DESCRIPTION')}</pre>
          </div>
          <div className="payments">
            <h2>{t('RULES_PAYMENTS')}</h2>
            <div className="margin-top-10">
              <PayTable/>
            </div>
            <pre>{t('RULES_PAYMENTS_DESCRIPTION')}</pre>
          </div>
        </div>
      </div>
    </ModalWrapper>
  );
});
